import React, { ReactNode } from 'react';
import { Button, ButtonProps } from '@mui/material';
import { Link } from 'react-router-dom';

interface IUIButtonProps extends ButtonProps {
  link?: string;
}

const UIButton: React.FC<IUIButtonProps> = ({ link, ...props }) => {
  const withLink = (element: ReactNode) =>
    link ? <Link to={link}>{element}</Link> : element;

  return withLink(<Button {...props} />);
};

export default UIButton;
